import type { ReactNode } from 'react';

export const symbol_coffee_maker: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-23 0-41.5-18T160-140v-680q0-23 18.5-41.5T220-880h550q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-77v60q0 14-12.5 27T654-720H368q-14 0-26.5-13T329-760v-60H220v680h188q-38-26-58.5-63T329-293v-133q0-24.75 17.63-42.38Q364.25-486 389-486h244q24.75 0 42.38 17.62Q693-450.75 693-426v133q0 53-21 90t-59 63h157q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q782.75-80 770-80H220Zm290.5-86q51.5 0 87-37.04T633-293v-133H389v133q0 52.92 35 89.96Q459-166 510.5-166ZM538-571q11-11 11-28t-11-28q-11-11-28-11t-28 11q-11 11-11 28t11 28q11 11 28 11t28-11Zm-27 145Z"
		/>
	</svg>
);
